// Small unread-count pill, anchored to a `relative` parent (nav bell icon).
// Coral deliberately — a badge is an alert, not a nav state, so it's the one
// place brand-accent outranks brand-primary in the nav.
const UnreadBadge = ({ count }) => {
  if (!count) return null;
  return (
    <span
      className="absolute -top-1 -right-2 min-w-[16px] h-4 px-1 rounded-full text-[10px] font-bold text-white flex items-center justify-center pointer-events-none"
      style={{ backgroundColor: 'var(--brand-accent)' }}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default UnreadBadge;
